import { createFileRoute } from '@tanstack/react-router';

import { SettingsLayout } from '@apps/web/features/settings';
import { modeStore } from '@apps/web/lib/mode_store';

export const Route = createFileRoute('/_app/settings')({
    // Preserve the sandbox/live mode context the old (main) layout provided.
    beforeLoad: modeStore.activate,
    onLeave: modeStore.deactivate,
    head: () => ({
        meta: [
            {
                title: 'Settings | Phoebe',
            },
        ],
    }),
    component: SettingsLayout,
});
